import { ReactNode } from 'react'

import { Button, ButtonProps, CircularProgress, makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    disabledBtn: {
        '&.Mui-disabled': {
            pointerEvents: 'auto',
            backgroundColor: '#ffffff80',
            '&:hover': {
                backgroundColor: '#ffffff80'
            }
        }
    },
    progress: {
        marginLeft: theme.spacing(0.5),
        color: 'gray'
    }
}))

type Props = {
    loading: boolean
    children: ReactNode
} & ButtonProps

export const LoadingButton = ({ loading, children, ...props }: Props) => {
    const classes = useStyles()

    return (
        <Button {...props} disabled={loading} classes={{ root: classes.disabledBtn }}>
            {children}
            {loading && <CircularProgress className={classes.progress} size={14} />}
        </Button>
    )
}
